export default __webpack_public_path__ + "static/media/Montserrat.b71748ae.woff2";